export default __webpack_public_path__ + "static/media/boo-gradient.48d5beb8.png";